var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIccompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#26c3c0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_20152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.0625 20.3125V33.4375C36.0625 34.473 35.223 35.3125 34.1875 35.3125H15.8125C14.777 35.3125 13.9375 34.473 13.9375 33.4375V20.3125M15.8125 18.4375H34.1875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.125 25.9375H19.5625C16.4559 25.9375 13.9375 23.4191 13.9375 20.3125C13.9375 19.277 14.777 18.4375 15.8125 18.4375H34.1875C35.223 18.4375 36.0625 19.277 36.0625 20.3125C36.0625 23.4191 33.5441 25.9375 30.4375 25.9375H26.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 18.4375C19.375 16.3664 21.0539 14.6875 23.125 14.6875H26.875C28.9461 14.6875 30.625 16.3664 30.625 18.4375M26.875 25.9375C26.875 26.973 26.0355 27.8125 25 27.8125C23.9645 27.8125 23.125 26.973 23.125 25.9375V24.0625H26.875V25.9375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_20152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIccompany);
export default __webpack_public_path__ + "static/media/iccompany.bee649610bcde51f223903a1e1b9331c.svg";
export { ForwardRef as ReactComponent };